import SubscriptionLayout from "./SubscriptionLayout";
import { providerRoutes } from "./modules/providers/routes";
import { serviceRoutes } from "./modules/services/routes";
import { packageRoutes } from "./modules/packages/routes";
import { collectionRoutes } from "./modules/collections/routes";
import { appointmentRoutes } from "./modules/appointments/routes";
import { subscriberRoutes } from "./modules/subscribers/routes";
import { serviceCategoryRoutes } from "./modules/service-categories/routes";
import { receiptRoutes } from "./modules/receipts/routes";
import { couponRoutes } from "./modules/coupons/routes";
import { requestedPackageRoutes } from "./modules/requested-packages/routes";
import { ratingsRoutes } from "./modules/ratings/routes";
import { recurringRoutes } from "./modules/recurring/routes";

export const subscriptionRoutes = {
  path: "subscriptions",
  component: SubscriptionLayout,
  children: [
    ...appointmentRoutes(),
    ...collectionRoutes(),
    ...packageRoutes(),
    ...providerRoutes(),
    ...receiptRoutes(),
    ...serviceRoutes(),
    ...serviceCategoryRoutes(),
    ...subscriberRoutes(),
    ...couponRoutes(),
    ...requestedPackageRoutes(),
    ...ratingsRoutes(),
    ...recurringRoutes()
  ]
};



// WEBPACK FOOTER //
// ./src/features/subscriptions/routes.js